"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const reducers_1 = require("../../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const NotificationAttachmentURL_1 = require("./NotificationAttachmentURL");
const MobilePopover_1 = require("../../components/MobilePopover");
const actions_1 = require("../../../../actions/");
const NotificationAttachmentPicker = ({ activePopover, children, closePopoverModalForm, deliverable, device, isPopoverOpen, openPopoverModalForm, updateActivePopover, updateEditingField, updateNotificationDeliverable, tempNotificationAttachment, updateTempNotificationAttachmentFields, }) => {
    const { attachment } = deliverable;
    const popoverProps = {
        placement: 'left',
    };
    const open = () => {
        updateActivePopover('notification-attachment-picker');
        openPopoverModalForm();
    };
    const close = () => {
        switch (device) {
            case 'Mobile':
                updateTempNotificationAttachmentFields(Object.assign({}, attachment));
                closePopoverModalForm();
                updateEditingField();
                setTimeout(() => {
                    updateActivePopover('');
                }, 500);
                break;
            case 'Desktop':
            case 'Tablet':
            default:
                updateEditingField();
                updateActivePopover('');
                break;
        }
    };
    return (React.createElement("div", { style: {
            height: attachment ? 96 : 72,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            borderBottom: `1px solid ${src_1.titanium}`,
        }, onClick: () => activePopover !== 'notification-attachment-picker' && open() },
        attachment ? (React.createElement(NotificationAttachmentURL_1.default, { notificationAttachment: attachment })) : (React.createElement(src_1.Text, { text: "Rich Media Attachment", size: "large", textStyle: { flex: '1 1 auto', color: src_1.steel } })),
        attachment && attachment.type === 'IMAGE' && (React.createElement("img", { src: attachment.url, style: {
                height: 48,
                width: 48,
                borderRadius: 4,
                flex: 'none',
            } })),
        React.createElement("div", { style: { flex: '0 0 auto', marginLeft: 16 } },
            device !== 'Mobile' && (React.createElement(src_1.PopoverContainer, { id: "rich-media-attachment-popover", popoverProps: popoverProps, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: activePopover !== 'notification-attachment-picker' ? open : close, showPopover: activePopover === 'notification-attachment-picker' }, children)),
            device === 'Mobile' && activePopover !== 'notification-attachment-picker' && children[0]),
        device === 'Mobile' &&
            activePopover === 'notification-attachment-picker' &&
            ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { children: children[1], animation: isPopoverOpen, navbarProps: {
                    buttonLeftCallback: () => close(),
                    buttonRight: 'Add',
                    buttonRightCallback: () => {
                        closePopoverModalForm();
                        updateEditingField();
                        updateNotificationDeliverable({
                            attachment: tempNotificationAttachment,
                        });
                        setTimeout(() => {
                            updateActivePopover('');
                        }, 500);
                    },
                } }), document.getElementById('mainModalLeft'))));
};
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    deliverable: reducers_1.getEditableCampaignDeliverable(state),
    isPopoverOpen: reducers_1.getIsPopoverModalFormOpen(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        openPopoverModalForm: () => {
            dispatch(actions_1.openPopoverModalForm());
        },
        closePopoverModalForm: () => {
            dispatch(actions_1.closePopoverModalForm());
        },
        updateActivePopover: (field) => {
            dispatch(actions_1.updateActivePopover(field));
        },
        updateNotificationDeliverable: (x) => dispatch(actions_1.updateNotificationDeliverable(x)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(NotificationAttachmentPicker);
